import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: values => axios.put("/api/me", values).then(res => res.data),
        onSuccess() {
            queryClient.refetchQueries(["me"]);
        }
    });
}
